<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
              <b-col>
              <list-report-head :base-url="awarenessEventServiceBaseUrl" uri="/configuration/report-heading/detail" :org-id="3">
                  {{ $t('assitive_device_management.patient_affairs_officer_demand') }} {{ $t('globalTrans.details') }}
              </list-report-head>
              </b-col>
            </b-row>
            <b-row>
                <b-col lg="12" sm="12">
                    <b-overlay :show="loading">
                        <b-table-simple hover small caption-top>
                                <b-tr>
                                    <b-th style="width:15%">{{ $t('assitive_device_management.idsc_center') }}</b-th>
                                    <b-th class="text-center" style="width: 2%">:</b-th>
                                    <b-td>{{ currentLocale === 'en' ? formData.center_name : formData.center_name_bn  }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th style="width:15%">{{ $t('globalTrans.fiscal_year') }}</b-th>
                                    <th class="text-center" style="width: 2%">:</th>
                                    <b-td>{{ currentLocale === 'en' ? formData.fiscal_year : formData.fiscal_year_bn  }}</b-td>
                                    <!-- <b-td>
                                        <slot v-if="$i18n.locale=='en'">{{ $store.state.commonObj.fiscalYearList.find(doc => doc.value === parseInt(formData.fiscal_year_id)).text_en }}</slot>
                                        <slot v-if="$i18n.locale=='bn'">{{ $store.state.commonObj.fiscalYearList.find(doc => doc.value === parseInt(formData.fiscal_year_id)).text_bn }}</slot>
                                    </b-td> -->
                                </b-tr>
                                <b-tr>
                                    <b-th style="width:15%">{{ $t('assitive_device_management.demand_date') }}</b-th>
                                    <th class="text-center" style="width: 2%">:</th>
                                    <b-td>{{ formData.application_date|dateFormat }}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-th style="width:15%">{{ $t('globalTrans.status') }}</b-th>
                                    <th class="text-center" style="width: 2%">:</th>
                                    <b-td>
                                      <span v-if="formData.status == 3">{{$t('globalTrans.approved')}}</span>
                                      <span v-if="formData.status == 4">{{$t('globalTrans.rejected')}}</span>
                                      <span v-if="formData.status == 1" style="color: black;">{{$t('globalTrans.pending')}}</span>
                                      <span v-if="formData.status == 5" style="color: black;">{{ $t('assitive_device_management.partially_distributed') }}</span>
                                      <span v-if="formData.status == 6" style="color: black;">{{ $t('assitive_device_management.distributed') }}</span>
                                    </b-td>
                                </b-tr>
                        </b-table-simple>
                        <b-overlay>
                        <template>
                            <div style="font-size:14px; background-color: #2486C4; padding:6px" class="mt-4">
                                <h5 class="text-white text-center"> {{ $t('assitive_device_management.assistive_device_info') }}</h5>
                            </div>
                        </template>
                        <b-overlay>
                            <b-table-simple bordered>
                                <b-tr>
                                    <th class="text-center" style="width:10%">{{ $t('globalTrans.sl_no') }}</th>
                                    <th class="text-center" style="width:30%">{{ $t('assitive_device_management.assistive_device_name') }}</th>
                                    <th class="text-right" style="width:20%">{{ $t('assitive_device_management.demand_quantity') }}</th>
                                    <th class="text-right" style="width:20%">{{ $t('assitive_device_management.approved_quantity') }}</th>
                                </b-tr>
                                <tr v-for="(indexData,index) in formData.details" :key="index">
                                    <td class="text-center">{{$n(index+1)}}</td>
                                    <b-td class="text-center" style="width:20%">
                                        <slot v-if="$i18n.locale=='en'">{{ $store.state.AwarenessEventService.commonObj.assistiveDeviceList.find(doc => doc.value === parseInt(indexData.assistive_device_id)).text_en }}</slot>
                                        <slot v-if="$i18n.locale=='bn'">{{ $store.state.AwarenessEventService.commonObj.assistiveDeviceList.find(doc => doc.value === parseInt(indexData.assistive_device_id)).text_bn }}</slot>
                                    </b-td>
                                    <td class="text-right">
                                        {{ $n(indexData.no_of_quantity) }}
                                    </td>
                                    <td v-if="indexData.approved_quantity>0" class="text-right">
                                        {{ $n(indexData.approved_quantity) }}
                                    </td>
                                    <td v-else></td>
                                </tr>
                                <b-tr>
                                    <b-th colspan="2" class="text-right">{{ $t('sitePreference.grandTotal') }}</b-th>
                                    <b-th class="text-right">{{ $n(grandTotalInfo.demand_quantity) }}</b-th>
                                    <b-th v-if="grandTotalInfo.approve_quantity>0" class="text-right">{{ $n(grandTotalInfo.approve_quantity) }}</b-th>
                                    <b-th v-else></b-th>
                                </b-tr>
                            </b-table-simple>
                        </b-overlay>
                        </b-overlay>
                    </b-overlay>
                </b-col>
              </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { psoskDemandShow } from '../../api/routes'
import ListReportHead from '@/components/custom/ListReportHeadAwareness.vue'
import ExportPdf from './export_pdf_details_data'

export default {
  props: ['id', 'item'],
  components: {
    ListReportHead
  },
  data () {
    return {
      loading: false,
      formData: [],
      detailsData: [],
      awarenessEventServiceBaseUrl: awarenessEventServiceBaseUrl,
      grandTotalInfo: {
        demand_quantity: 0,
        approve_quantity: 0
      }
    }
  },
  created () {
    this.getEligibityCategory()
    // this.getGrandTotalInfo()
  },
  mounted () {
    core.index()
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
  },
  methods: {
    async getEligibityCategory () {
        this.loading = true
        const resultData = await RestApi.getData(awarenessEventServiceBaseUrl, psoskDemandShow + '/' + this.item.id)
        this.formData = this.getRelationalData(resultData.data)
        this.getGrandTotalInfo()
        this.loading = false
    },
    getRelationalData (item) {
        const fiscalYear = this.$store.state.commonObj.fiscalYearList.find(doc => doc.value === item.fiscal_year_id)
        const customItem = {
            fiscal_year: fiscalYear !== undefined ? fiscalYear.text_en : '',
            fiscal_year_bn: fiscalYear !== undefined ? fiscalYear.text_bn : ''
        }
        const centerList = this.$store.state.AwarenessEventService.commonObj.idscCenterList.find(service => service.value === item.center_id)
        const list = {
            center_name: centerList !== undefined ? centerList.text_en : '',
            center_name_bn: centerList !== undefined ? centerList.text_bn : ''
        }
        item.details = item.details.map(item1 => {
            const assistiveDevice = this.$store.state.AwarenessEventService.commonObj.assistiveDeviceList.find(doc => doc.value === parseInt(item1.assistive_device_id))
            const deviceObj = {
              device_name: assistiveDevice !== undefined ? assistiveDevice.text_en : '',
              device_name_bn: assistiveDevice !== undefined ? assistiveDevice.text_bn : ''
            }
            return Object.assign({}, item1, deviceObj)
          })
        return Object.assign({}, item, customItem, list)
    },
    getGrandTotalInfo () {
      let totalDemandQuantity = 0
      let totalApproveQuantity = 0
      this.formData.details.forEach(item => {
          totalDemandQuantity += parseFloat(item.no_of_quantity)
          totalApproveQuantity += parseFloat(item.approved_quantity)
      })
      this.grandTotalInfo = Object.assign({}, this.grandTotalInfo, {
          demand_quantity: totalDemandQuantity,
          approve_quantity: totalApproveQuantity
      })
    },
    pdfExport () {
      const reportTitle = this.$t('assitive_device_management.patient_affairs_officer_demand') + ' ' + this.$t('globalTrans.details')
      ExportPdf.exportPdfDetails(awarenessEventServiceBaseUrl, '/configuration/report-heading/detail', 3, reportTitle, this.formData, this, this.grandTotalInfo)
    }
  }
}
</script>
<style lang="scss">
    .details {
    h5 {
      color: green !important;
      font-size: 20px !important;
    }
    .table-bordered td:nth-child(2n+1) {
      font-weight: 700;
    }
  }
  .hidden_header {
    display: none
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
  .mytd{
        padding: 0.45rem 0.75rem 0.45rem 0.75rem !important;
    }
</style>
